import api from "../api";
import axios from "../utils/axios.instance";
import handleError from "./handle-error";

export const addSkill = async (payload) => {
  try {
    const { data } = await axios.post(api.addSkill, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const searchSkill = async (searchText, filters = {}) => {
  try {
    const params = {};
    if (filters?.classification) {
      params.classification = filters.classification;
    }
    if (filters?.subClassification) {
      params.subClassification = Array.isArray(filters.subClassification)
        ? filters.subClassification.filter(Boolean)
        : [filters.subClassification];
    }

    const { data } = await axios.get(
      api.skillSearch + `/${encodeURIComponent(searchText)}`,
      { params }
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const updateSkill = async (payload) => {
  try {
    const { data } = await axios.patch(api.updateSkill, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const deleteSkill = async (SkillId) => {
  try {
    const { data } = await axios.delete(api.deleteSkill + SkillId);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getSkills = async (payload) => {
  try {
    const type = payload?.type || 1;
    const { candidateId, jobId, jobRequirementId } = payload || {};

    let slug = "";
    if (candidateId && jobId) {
      slug = `candidateId=${candidateId}&jobId=${jobId}`;
    } else if (candidateId) {
      slug = `candidateId=${candidateId}`;
    } else if (jobId) {
      slug = `jobId=${jobId}`;
    } else if (jobRequirementId) {
      slug = `jobRequirementId=${jobRequirementId}`;
    }

    const { data } = await axios.get(api.listSkill + `?type=${type}&${slug}`);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getMatchedCandidates = async (payload) => {
  try {
    const { data } = await axios.post(api.getMatchedCandidate, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getReferralMatchedCandidates = async () => {
  try {
    const { data } = await axios.get(api.referralMatchedContacts);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getReferralMatchedContactDetails = async (id) => {
  try {
    const { data } = await axios.get(
      api.referralMatchedContactDetails + `/${id}`
    );
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getSkillIndividualPercentage = async (payload) => {
  try {
    const { data } = await axios.post(
      api.getSkillIndividualPercentage,
      payload
    );
    return data;
  } catch (err) {
    return handleError(err);
  }
};
